module.exports = __webpack_public_path__ + "static/carbon-316b3c125ae5c28ac42d262528abe199.jpg";